import React from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import {Button, refreshView} from 'react-admin';
import DeleteIcon from '@material-ui/icons/Delete';
import Swal from 'sweetalert2';
import withStyles from '@material-ui/core/styles/withStyles';
import axiosInstance from '../api/axios';
import {showErrorNotify, showSuccessNotify} from './ShowNotify';

const styles = {
    redColor: {
        color: 'red',
    },
};

const DeleteBatchWithAuthStatusButton = (props) => {
    const {
        record,
        basePath,
        refreshView,
        classes,
        title = 'Bạn chắc chắn muốn huỷ kế hoạch?',
        text = 'Những hoá đơn chưa thanh toán cũng sẽ bị huỷ. Không thể hoàn tác sau khi huỷ.',
        successMessage = 'Huỷ kế hoạch thành công!',
    } = props;

    if (!record) return null;

    // ưu tiên authStatus, fallback sang status
    const currentStatus = record.authStatus || record.status;

    // Không cho xoá nếu đã AUTHORIZED
    if (currentStatus === 'AUTHORIZED') {
        return null;
    }

    const handleDelete = () => {
        Swal.fire({
            title,
            text,
            type: 'warning',
            showCloseButton: true,
            showCancelButton: true,
            cancelButtonColor: '#d33',
            focusConfirm: false,
        }).then((result) => {
            if (!result.value) return;

            axiosInstance
                .delete(`/api${basePath}/${record.id}`)
                .then(() => {
                    showSuccessNotify(successMessage);
                    refreshView();
                })
                .catch(() => {
                    showErrorNotify('Có lỗi xảy ra. Vui lòng liên hệ quản trị viên!');
                });
        });
    };

    return (
        <Button
            label="ra.action.destroy"
            onClick={handleDelete}
            className={classes.redColor}
        >
            <DeleteIcon/>
        </Button>
    );
};

const mapDispatchToProps = {
    refreshView,
};

export default compose(
    connect(null, mapDispatchToProps),
    withStyles(styles)
)(DeleteBatchWithAuthStatusButton);
